module.exports = __webpack_public_path__ + "img/cover-nicetohave-product-design.0ecc9bf6.jpg";